/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetInfrastructureModel,
  IGetInfrastructureRequest,
  IMappers,
  IGetInfrastructureResponse,
  IGetInfrastructureResponseError,
  TGetInfrastructureResponse,
} from './types';

const defaultConfig: TGetInfrastructureModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'newbuilding-card',
  pathApi: '/v1/get-infrastructure/',
  hostType: 'api',
} as TGetInfrastructureModel;

function createGetInfrastructureModel(parameters: IGetInfrastructureRequest): TGetInfrastructureModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetInfrastructureOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetInfrastructureRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetInfrastructure<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetInfrastructureOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetInfrastructureResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetInfrastructureModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetInfrastructureResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetInfrastructureResponseError);
    }
  }

  return { response, statusCode } as TGetInfrastructureResponse;
}

export { defaultConfig, createGetInfrastructureModel, fetchGetInfrastructure };
